import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, createStatuses } from 'store/data/statuses';

export function useCreateStatuses(): Operation<(labels: string[]) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.CREATE_STATUSES);

	async function handler(labels: string[]) {
		if (loading) return;
		if (error) resetError();

		await dispatch(createStatuses(labels));
	}

	return [{ loading, error }, handler];
}
